import { CSSProperties } from 'react';

import { Button } from 'antd';

import { copyTableToClipboard, TableRow } from '../../../../../helpers/utils/functions';
interface Column {
    title: string;
    dataIndex: string;
    key: string;
    filters?: any
    onFilter?: (value: any, record: any) => boolean;
    render?: (value: any, record: any) => JSX.Element;
}

type Props = {
    columns:Column[],
    tableData:TableRow[],
    styles:CSSProperties
}
export default function CopyButton({ columns,tableData,styles }:Props){
    return (
        <Button style={styles} type="primary" onClick={()=>copyTableToClipboard(columns,tableData)}>Копировать данные из таблицы</Button>
    );
}
